<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex" *ngIf="!isLoading; else spinner">
            <div class="dialog-title" data-cy="channels-print-modal-header">
                {{ getTranslationString('print.dialog.title.') | translate }}
            </div>

            <div class="content-container">
                <div class="option-container" *ngIf="pageType == SENSOR_FU_PRINT">
                    <div class="option-right-container">
                        {{ 'print.dialog.select.title.sensor-cable-tag' | translate }}
                    </div>
                    <div class="option-left-container">
                        <app-simple-dropdown
                            [options]="fcuDropdownOptions"
                            [selectedOption]="selectedFcuNum"
                            (onOptionSelected)="onFcuSelected($event)"
                            [width]="120">
                        </app-simple-dropdown>
                    </div>
                </div>

                <ng-container *ngIf="pageType != ALARM_GROUP_PRINT && pageType != REPOSE_GROUP_PRINT">
                    <div
                        class="option-container"
                        [class.disabled]="isContainerSelectionsDisabled">
                        <div class="option-right-container" data-cy="channels-print-channel-groups-label">
                            {{ getTranslationString('print.dialog.select.title.') | translate }}
                        </div>

                        <div
                            class="option-left-container">
                            <mat-radio-group class="option-left-container">
                                <mat-radio-button
                                    data-cy="channels-print-all-groups-radio-button"
                                    [checked]="printAll"
                                    [value]="printAll"
                                    [disabled]="pageType == SINGLE_MIMIC_PRINT"
                                    [class.disabled]="pageType == SINGLE_MIMIC_PRINT"
                                    disableRipple
                                    (click)="printAllRadioClicked($event, true)">
                                    {{ getTranslationString('print.dialog.select.all.') | translate }}
                                </mat-radio-button>

                                <div class="selector-wrapper">
                                    <mat-radio-button
                                        data-cy="channels-print-selected-groups-radio-button"
                                        [checked]="!printAll"
                                        [value]="!printAll"
                                        disableRipple
                                        (click)="printAllRadioClicked($event, false)">
                                        {{ getTranslationString('print.dialog.select.option.') | translate }}
                                    </mat-radio-button>
                                    <app-simple-dropdown
                                        [options]="dropdownOptions"
                                        [selectedOptions]="selectedOptionItems"
                                        [type]="DropdownType.Checkbox"
                                        [legend]="getTranslationString('print.dialog.select.input.legend.')"
                                        [width]="456"
                                        [isDisabled]="isDisabledField(OPTIONS_FIELD)"
                                        (onOptionsSelected)="onDropdownOptionsSelected($event)">
                                    </app-simple-dropdown>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                </ng-container>

                <div class="option-container" [class.disabled]="isContainerSelectionsDisabled">
                    <div class="option-right-container">
                        <div data-cy="channels-print-print-updates-label">
                            {{ 'print.dialog.updates.title' | translate }}
                        </div>
                        <div class="info-container">
                            <mat-icon
                                data-cy="channels-print-print-updates-tooltip"
                                svgIcon="help"
                                style="cursor: pointer">
                            </mat-icon>
                            <div
                                #infoMessage
                                class="info-message-container"
                                data-cy="channels-print-print-updates-tooltip-text">
                                {{ 'print.dialog.updates.info1' | translate }}
                                <span class="regular">
                                    {{ 'print.dialog.updates.info2' | translate }}
                                </span>
                                {{ 'print.dialog.updates.info3' | translate }}.
                            </div>
                        </div>
                    </div>
                    <div class="option-left-container">
                        <mat-radio-group class="option-left-container" [value]="compareVersions">
                            <div
                                [matTooltip]="'print.dialog.updates.with.tooltip' | translate"
                                [matTooltipDisabled]="hasOldVersions"
                            >
                                <mat-radio-button
                                    class="with-updates"
                                    [value]="true"
                                    [disabled]="isPrintWithUpdatesDisabled"
                                    disableRipple
                                    (click)="compareVersionRadioChanged(true)"
                                >
                                    {{ 'print.dialog.updates.with' | translate }}
                                </mat-radio-button>
                            </div>
                            
                            <ng-container *ngTemplateOutlet="versionList;"></ng-container>
                            
                            <mat-radio-button
                                class="without-updates"
                                [value]="false" 
                                [disabled]="false"
                                disableRipple
                                (click)="compareVersionRadioChanged(false)">
                                {{ 'print.dialog.updates.without' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="footer-container">
                    <div class="back button" *ngIf="!notFromMain" (click)="back()">
                        {{ 'dlg.back' | translate }}
                    </div>
                    <div class="buttons-container">
                        <div class="button" (click)="cancel()">
                            {{ 'print.dialog.button.cancel' | translate }}
                        </div>
                        <div
                            class="button button-print"
                            data-cy="channels-print-modal-print-button"
                            [class.disabledPrint]="isPrintDisabled()"
                            (click)="print()">
                            {{ 'print.dialog.button.print' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #spinner>
        <div class="spinner-container">
            <app-loading-spinner
                [custom]="true"
                class="spinner-component"
                size="80"
                strokeWidth="3">
            </app-loading-spinner>
        </div>
    </ng-template>
</div>

<ng-template #versionList>
    <app-simple-dropdown
        [options]="versionsDropdownOptions"
        [selectedOption]="versionToCompare"
        [type]="DropdownType.Radio"
        [legend]="'print.dialog.updates.input.legend'"
        [width]="456"
        [isDisabled]="!compareVersions"
        (onOptionSelected)="onVersionDropdownSelected($event)">
    </app-simple-dropdown>
</ng-template>